module.exports = __webpack_public_path__ + "media/images/story/icon/chevron-right-cdaa962d2db003a0185e1317ff8f8cb8.svg";